(window as any).global = window;

export const NOOP = 0;
